export default __webpack_public_path__ + "static/media/a13a77ba2c2b889af005f0479d536d28.svg";